import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import DeleteJobDescriptionFromExternalWebsiteForm from './DeleteJobDescriptionFromExternalWebsiteForm';

import { useJobDescriptionsFromExternalWebsitesState, useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';

const DeleteJobDescriptionFromExternalWebsiteModal = () => {
  const jobDescriptionsFromExternalWebsitesState = useJobDescriptionsFromExternalWebsitesState();
  const { closeDeleteJobDescriptionFromExternalWebsiteModal } = useJobDescriptionsFromExternalWebsitesActions();

  return (
    <StandardModal
      isOpen={jobDescriptionsFromExternalWebsitesState?.deleteJobDescriptionFromExternalWebsiteModalIsOpen}
      contentLabel={'Delete Job Description from External Website'}
      onRequestClose={() => {
        closeDeleteJobDescriptionFromExternalWebsiteModal();
      }}
    >
      <DeleteJobDescriptionFromExternalWebsiteForm />
    </StandardModal>
  );
};

export default DeleteJobDescriptionFromExternalWebsiteModal;